import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getAppointmentCounts } from '@uplift/api';

export const useAggregateAppointmentCounts = (providerId: string) => {
  const queryClient = useQueryClient();

  const refetch = async () => {
    await queryClient.invalidateQueries({ queryKey: [ 'appointment', providerId, 'counts' ] });
  };

  const { data, isLoading } = useQuery({
    queryFn: getAppointmentCounts,
    queryKey: [ 'appointment', providerId, 'counts' ],
    enabled: !!providerId
  });

  return { patientCounts: data, fetching: isLoading, refetch };
};
